// A dataLayer event payload — an arbitrary bag of keys GTM reads. Kept local so
// this wrapper doesn't couple to @gtm-support/core's types (removed in Step 2).
type TrackEventOptions = Record<string, unknown>

export const useKftGtm = (): any => {
  const config = useRuntimeConfig()
  const gtm = useGtm()
  const isNotProduction = config.public.appEnv !== 'production'

  if (isNotProduction) {
    gtm?.debugEnabled(false)
    gtm?.debug(false)
  }

  const trackEvent = isNotProduction
    ? (args: TrackEventOptions = {}) => {
        console.log(
          '%cGTM',
          'background: #2E495E;border-radius: 0.5em;color: white;font-weight: bold;padding: 2px 0.5em;',
          args
        )
      }
    : gtm?.trackEvent

  const pushToDataLayer = (args: TrackEventOptions = {}) => {
    if (isNotProduction) {
      console.log(
        '%cGTM',
        'background: #2E495E;border-radius: 0.5em;color: white;font-weight: bold;padding: 2px 0.5em;',
        args
      )
      return
    }

    if (!import.meta.client) return

    // KFT-3883: push straight to window.dataLayer instead of gating on
    // gtm.enabled(). gtm.enable() is now deferred to browser idle (see
    // 3.gtm.global.ts), so gating here would silently drop any event fired
    // before idle — e.g. the social-login conversion on the post-OAuth page.
    // window.dataLayer IS GTM's native buffer: @gtm-support/core preserves an
    // existing array and gtm.js replays every prior push when it loads, so
    // pre-enable events are retained and processed once GTM boots.
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(args)
  }

  const enable = isNotProduction ? () => {} : gtm?.enable

  return {
    ...(gtm && gtm),
    trackEvent,
    pushToDataLayer,
    enable,
  }
}
